// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_q-0";
export var skeletonCard = "_q-1";